import styled, { css } from "styled-components";

export const Footer = styled.footer<{ active?: boolean }>`
    display: flex;
    justify-content: space-between;
    width: 100%;
    border-top: 1px solid var(--color-grey-4);

    & > div:nth-child(2) {
        display: flex;
        align-items: flex-start;
        column-gap: var(--spacing-2);

        & > span {
            line-height: 3.2rem; /* Text should be the same height as checkbox */
        }

        @supports not (padding-inline: 0) {
            & > *:not(:nth-last-child(1)) {
                margin-right: var(--spacing-2);
            }
        }
    }

    ${({ active }) =>
        active &&
        css`
            display: block;
            padding: 0;
            > button {
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: var(--color-primary-white);
                border-top: 1px solid var(--color-grey-4);
                border-radius: 0 0 3px 3px;
            }
        `};
`;

export const DeliveryInfo = styled.div``;

export const CtaTrigger = styled.button`
    all: unset;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding: var(--spacing-2);

    &:is(:hover, :active, :focus) {
        label {
            color: var(--color-primary-white);
            background-color: var(--color-primary-black);
            border-color: var(--color-primary-black);
        }
    }

    /* Pointer events should be removed from components inside the button,
    otherwise it will trigger multiple times the CarDeliveryService modal. */
    & > * {
        pointer-events: none;
    }
`;

export const Cta = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: var(--spacing-2);

    &:only-child {
        width: 100%;
    }

    @supports not (padding-inline: 0) {
        & > *:not(:nth-last-child(1)) {
            margin-right: var(--spacing-2);
        }
    }
`;

export const DeliveryConfig = styled.div`
    padding: var(--spacing-2);
    background: var(--color-grey-1);
`;
export const DeliveryConfigHeader = styled.div`
    margin-bottom: calc(var(--spacing-3) / 2);
    padding-bottom: calc(var(--spacing-3) / 2);
    font-family: var(--font-semi-bold);
    font-size: 1.3rem;
    line-height: 2rem;
    text-transform: uppercase;
    border-bottom: 1px solid var(--color-grey-4);
`;

export const DeliveryConfigContent = styled.div`
    display: flex;
    justify-content: space-between;
    gap: var(--spacing-2);
`;
export const DeliveryMethod = styled.div`
    display: flex;
    align-items: center;
    gap: var(--spacing-1);
    margin-block: var(--spacing-1);
`;
